<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts'
import chartResize from './mixins/chart-resize'

export default {
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    xAxisName: {
      type: String,
      default: ''
    },
    yAxisName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions(data) {
      this.chart.setOption({
        grid: { 
          left: '5%',
          right: '5%',
          top: '20%',
          bottom: '10%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
          }, 
        },
        xAxis: [{
          type: 'category',
          name: this.xAxisName,
          nameTextStyle: {
            color: '#9ab9ca',
          },
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#18396E'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#9ab9ca'
            },
            formatter: (val) => {
              return val.slice(6,8);
            }
          },
          data: this.chartData.days
        }],
        yAxis: [{
          type: 'value',
          name: this.yAxisName,
          nameTextStyle: {
            color: '#9ab9ca',
            padding: 0
          },
          axisLine: {
            lineStyle: {
              color: '#18396E'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#9ab9ca'
            }
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: "",
          type: 'line',
          smooth: true,
          symbol: 'none',
          interval: true,
          itemStyle: {
            normal: {
              areaStyle: {
                opacity: 0.2,
                color: '#2CC8FF'
              }
            }
          },
          markPoint: {
            symbol: 'circle',
            symbolSize:5,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 1,
                  color: '#2CC8FF'
                }
              }
            },
            data: [{
              type: 'max',
              name: '最大值'
            }]
          },
          lineStyle: {
            normal: {
              width: 1
            }
          },
          color: ['#2CC8FF'],
          data: this.chartData.data,
        }]
      })
    },
  }
}
</script>
